<ng-container *transloco="let t">
  <div class="statement-origin-picker" (click)="onPickerOpenIntent()">
    <mzic-select
      [searchable]="true"
      [loading]="hydrating"
      [showSearchLoading]="searching"
      [optionsSelected]="selectedOptions"
      [placeholder]="
        t('lang.file_required_inputs_statement_origin_placeholder')
      "
      [disabled]="disabled"
      [invalid]="invalid"
      (searchTextChange)="onSearchTextChange($event)"
      (closedChange)="onClosedChange()">
      <div
        content
        role="listbox"
        [attr.aria-label]="
          t('lang.file_required_inputs_statement_origin_label')
        ">
        @for (row of rows; track row.id) {
          <mzic-option
            role="option"
            [attr.aria-selected]="isSelected(row)"
            [id]="row.id"
            [value]="row.display_name"
            (optionChange)="onPick(row)">
            <div class="select-option">
              <div class="select-option__image">
                @if (row.icon_url) {
                  <img [src]="row.icon_url" [alt]="row.display_name" />
                } @else {
                  <span
                    class="statement-origin-picker__initial"
                    aria-hidden="true">
                    {{ initialFor(row) }}
                  </span>
                }
              </div>
              <div class="select-option__main">
                <header>
                  <div class="select-option__main-title">
                    {{ row.display_name }}
                  </div>
                </header>
                @if (row.description) {
                  <div class="select-option__main-description">
                    {{ row.description }}
                  </div>
                }
              </div>
            </div>
          </mzic-option>
        }

        @if (showEmptyState) {
          <p class="statement-origin-picker__notice">
            {{ t('lang.file_required_inputs_statement_origin_no_results') }}
          </p>
        }

        @if (loadFailed) {
          <p class="statement-origin-picker__notice" role="alert">
            {{ t('lang.file_required_inputs_statement_origin_load_error') }}
          </p>
        }
      </div>
    </mzic-select>
  </div>
</ng-container>
